import * as Sentry from '@sentry/nextjs'

// Records a user-flow step as a Sentry breadcrumb. Breadcrumbs are attached to whatever
// error/exception gets captured next (automatically or via Sentry.captureException), so
// calling this at key interaction points builds the "what did the user do before this broke"
// trail on the Sentry issue, without needing to log/capture anything itself.
export function trackUserAction(message: string, data?: Record<string, unknown>) {
  Sentry.addBreadcrumb({
    category: 'user-action',
    message,
    level: 'info',
    data,
  })
}
